module.exports = __webpack_public_path__ + "img/numbers.5c12cdaf.svg";